export default {
    data() {
        return {
            localizedTexts: {
                contentTitle: this.$l10n.__("Détails de l'activité"),
                label: this.$l10n.__('Label'),
                staffs: this.$l10n.__('Collaborateur(s)'),
                searchStaffs: this.$l10n.__('Chercher un collaborateur'),
                saveBtn: this.$l10n.__('Enregistrer'),
                cancelBtn: this.$l10n.__('Annuler'),
                placeholderActivityTitle: this.$l10n.__('Activité sans titre'),
                source: this.$l10n.__('Source'),
                description: this.$l10n.__('Description'),
                contacts: this.$l10n.__('Contacts'),
                searchContacts: this.$l10n.__('Ajouter des invités'),
                noResults: this.$l10n.__('Aucun résultat trouvé'),
                phonecall: {
                    incoming: this.$l10n.__('Appel entrant'),
                    outcoming: this.$l10n.__('Appel sortant'),
                    titleCallDone: this.$l10n.__('Ajouter un appel'),
                    titleCallScheduled: this.$l10n.__('Nouvel appel programmé'),
                    duration: this.$l10n.__("Temps d'appel"),
                    result: this.$l10n.__("Résultat d'appel"),
                },
                advancedSettings: this.$l10n.__('Paramètres avancés'),
                privacy: {
                    title: this.$l10n.__('Confidentialité'),
                    private: this.$l10n.__('Privé'),
                    public: this.$l10n.__('Public'),
                },
                priority: this.$l10n.__('Priorité'),
            },
            optionsRichText: [
                'Attachment',
                'Bold',
                'Italic',
                'Underline',
                'TextAlign',
                'BulletList',
                'OrderedList',
                'Divider',
                'Link',
            ],
            metas: {},
        };
    },
    computed: {
        activityIsPrioritized() {
            return this.activityFormData.priority > 0;
        },
    },
    watch: {
        async id(newId, oldId) {
            if (newId !== oldId) {
                if (this.$store.getters['activitiesStores/getActivityDataPanel']) {
                    await this.$store.dispatch('activitiesStores/updateActivityDataPanel', null);
                }
                await this.initPanel();
            }
        },
    },
    beforeDestroy() {
        if (this.$store.getters['activitiesStores/getActivityDataPanel']) {
            this.$store.dispatch('activitiesStores/updateActivityDataPanel', null);
        }
    },
    methods: {
        togglePriority() {
            this.activityFormData.priority = this.activityIsPrioritized ? 0 : 1;
        },
    },
};
